module.exports={
    "over_size_message":"Η εικόνα που ανεβάσατε είναι πάνω από 10MB. Θα συμπιέσουμε το αρχείο σας για μεταφόρτωση. Κάντε κλικ στο \"Επιβεβαίωση\" για να συνεχίσετε τη μεταφόρτωση.",
    "file_type_error":"Το αρχείο που ανεβάσατε δεν είναι εικόνα! Προσπαθήστε να ανεβάσετε ξανά.",
    "upload_error":"Σφάλμα μεταφόρτωσης! (Κωδικός σφάλματος: 2000) Δοκιμάστε ξανά.",
    "watermark_remove_over_size":"Η εικόνα που ανεβάσατε είναι πάνω από 5MB. Συνιστάται να χρησιμοποιείτε τον Δωρεάν διαδικτυακό συμπιεστή εικόνων μας. Κάντε κλικ για <a class=\"jump-link\" href=\"https://www.tipard.com/el/image-compressor-online/\">μάθετε περισσότερα</a>",
    "watermark_remove_file_type_error":"Το αρχείο που ανεβάσατε δεν είναι εικόνα, μεταφορτώστε ξανά.",
    "watermark_remove_image_type_error":"Η μορφή εικόνας δεν υποστηρίζεται. Υποστηρίζουμε μόνο JPG, JPEG, PNG και BMP.",
    "watermark_remove_upload_error":"Σφάλμα αναγνώρισης (κωδικός σφάλματος: 2001), δοκιμάστε ξανά...",
    "watermark_remove_processing":"Επεξεργασία εικόνας...",
    "watermark_remove_not_save":"Η περιοχή που επιλέξατε δεν θα διατηρηθεί. Είστε βέβαιοι ότι θέλετε να το περικόψετε;",
    "watermark_remove_back_home":"Η τρέχουσα κατάσταση δεν θα αποθηκευτεί. Είστε βέβαιοι ότι θέλετε να επιστρέψετε στο σπίτι;",
    "watermark_remove_new_image":"Η τρέχουσα κατάσταση δεν θα αποθηκευτεί. Είστε βέβαιοι ότι θέλετε να επιλέξετε μια νέα εικόνα;",
    "watermark_select":"Επιλέγω",
    "watermark_select_area":"Επιλέξτε την περιοχή του υδατογραφήματος που θέλετε να διαγράψετε πριν κάνετε κλικ στην επιλογή Κατάργηση.",
    "watermark_beyond_4k":"Η επιλεγμένη εικόνα υπερβαίνει τα 4K ανάλυση. Λυπούμαστε που δεν μπορούμε να το επεξεργαστούμε αυτήν τη στιγμή",
    "watermark_beyond_pixel_1":"Η επιλεγμένη ανάλυση εικόνας υπερβαίνει το <span>%spx</span><span>&times;%spx</span>. Δεν είναι δυνατή η επεξεργασία του, επιλέξτε ξανά.",
    "watermark_beyond_pixel_2":"Οι επισκέπτες μπορούν να επεξεργαστούν μόνο <span>%s</span> εικόνες με ανάλυση πάνω από <span>%spx</span>x<span>%spx</span>, συνδεθείτε και συνεχίστε να χρησιμοποιείτε.",
    "watermark_beyond_size_1":"Το επιλεγμένο μέγεθος εικόνας υπερβαίνει τα <span>%sMB</span>. Δεν είναι δυνατή η επεξεργασία του, επιλέξτε ξανά.",
    "watermark_beyond_size_2":"Το επιλεγμένο μέγεθος εικόνας υπερβαίνει τα <span>%sMB</span>, αλλά οι επισκέπτες μπορούν να επεξεργαστούν μόνο εικόνες μικρότερες από <span>%sMB</span>. Παρακαλούμε συνδεθείτε και συνεχίστε να χρησιμοποιείτε.",
    "no_user_down":"Οι επισκέπτες μπορούν να κατεβάσουν εικόνες <span>%s</span> μόνο με αρχική ποιότητα. Παρακαλούμε συνδεθείτε και συνεχίστε τη λήψη. Επίσης, μπορείτε να διατηρήσετε το ιστορικό 7 ημερών μετά τη σύνδεση. Συνεχίστε τη λήψη εικόνων με πλάτος ή υψηλό <span>%spx</span>.",
    "no_down_rights":"Δεν είναι δυνατή η λήψη εικόνων HD με αρχική ποιότητα, αναβαθμίστε το σχέδιό σας! Μπορείτε επίσης να συνεχίσετε τη λήψη εικόνων χαμηλής ποιότητας με το <span>%spx</span>.",
    "error_40001":"Σφάλμα: 40001. Επικοινωνήστε μαζί μας",
    "error_40099":"Σφάλμα: 40099. Επικοινωνήστε μαζί μας",
    "down_btn":"Η λήψη είναι σε προετοιμασία, περιμένετε για ένα δευτερόλεπτο...",
    "noRemove_down_btn":"Δεν έχετε κάνει τίποτα για την αφαίρεση υδατογραφημάτων. Επιλέξτε το υδατογράφημα που θέλετε να αφαιρέσετε και κάντε κλικ στο κουμπί Κατάργηση. Στη συνέχεια, μπορείτε να κάνετε λήψη της εικόνας σας.",
    "history_open":"Ανοίγοντας την τροποποιημένη εικόνα, περιμένετε λίγο...",
    "maskRightsMonitor_info":"Η σελίδα για την αναβάθμιση των παροχών έχει ανοίξει σε νέα καρτέλα και το σχέδιό σας θα συγχρονιστεί αυτόματα μετά την αναβάθμιση.",
    "maskLoginMonitor_info":"Η σελίδα προορισμού έχει ανοίξει, συμπληρώστε τη σύνδεση σε αυτήν. Αφού συνδεθείτε ή εγγραφείτε με επιτυχία, αυτή η σελίδα θα συγχρονιστεί αυτόματα, μην την κλείσετε.",
    "photo_rights_info":"Μπορείτε να κάνετε λήψη <span><i class=\"num\">2</i> εικόνων HD</span> με αρχική ποιότητα προς το παρόν. <a href=\"https://account.tipard.com\" target=\"_blank\">Προβολή λεπτομερειών>></a>",
    "rights_original":"Για να ενεργοποιήσετε τη ρύθμιση \"Χρήση της λειτουργίας Βελτιωτή εικόνας για μείωση της απώλειας ποιότητας\", πρέπει να αναβαθμίσετε τον λογαριασμό σας!",
    "Brush":"Βούρτσα",
    "Lasso":"Λάσο",
    "Polygonal":"Πολυγωνικό",
    "Eraser":"Γόμα",
    "Free":"Ελεύθερος",
    "More":"Περισσότερο:",
    "Select":"Επιλέγω",
    "Remove":"Αφαιρώ",
    "BrushSize":"Μέγεθος βούρτσας:",
    "AspectRatio":"Αναλογία απεικόνισης:",
    "Upload":"ΝΕΑ ΦΩΤΟΓΡΑΦΙΑ",
    "History":"Ιστορία",
    "Login":"Σύνδεση",
    "MyAccount":"Ο λογαριασμός μου",
    "Logout":"Αποσύνδεση",
    "Usinghelp":"Χρήση βοήθειας>>",
    "Enhancer":"Χρησιμοποιήστε τη λειτουργία Image Enhancer για να μειώσετε την απώλεια ποιότητας",
    "Download":"Κατεβάστε",
    "Guide":"Οδηγός",
    "Polygonal1":"Πολυγωνικό",
    "Polygonal_info":"Κάντε κλικ στο αριστερό κουμπί του ποντικιού για να προσδιορίσετε ένα σημείο κάθε φορά.",
    "Lasso1":"Λάσο:",
    "Lasso_info":"Πατήστε παρατεταμένα το αριστερό κουμπί του ποντικιού για να κάνετε λάσο στην περιοχή του υδατογραφήματος.",
    "Brush1":"Βούρτσα:",
    "Brush_info":"Πατήστε παρατεταμένα το αριστερό κουμπί του ποντικιού για να επιλέξετε με ακρίβεια.",
    "Eraser1":"Γόμα:",
    "Eraser_info":"Διαγράψτε τα περιττά μέρη από την επιλεγμένη περιοχή.",
    "Click":"Κάντε κλικ",
    "the":"ο",
    "click_info":"κουμπί για να αρχίσει να σβήνει το ανεπιθύμητο υδατογράφημα.",
    "PleaseUploadImages":"Παρακαλώ ανεβάστε εικόνες.",
    "CropInfo":"Μόλις ολοκληρωθεί η αφαίρεση του υδατογραφήματος, μπορείτε να κάνετε κλικ στο κουμπί Περικοπή για να περικόψετε την εικόνα σας πριν την αποθήκευση ή κάντε κλικ στο κουμπί Λήψη για να αποθηκεύσετε απευθείας την τρέχουσα εικόνα.",
    "Crop":"Καλλιέργεια",
    "Back":"Πίσω",
    "DownloadCropped":"Λήψη Περικομμένο",
    "Cancel":"Ματαίωση",
    "FreeWatermarkRemover":"Δωρεάν αφαίρεση υδατογραφημάτων",
    "Processing":"Επεξεργασία...",
    "NewImage":"Νέα εικόνα",
    "Retry":"Ξαναδοκιμάσετε",
    "Yes":"Ναί",
    "No":"Οχι",
    "FailureFeedback":"Ανατροφοδότηση αποτυχίας",
    "removeTip":"Αφού επιλέξετε την περιοχή υδατογραφήματος, κάντε κλικ στην Κατάργηση για να διαγράψετε το υδατογράφημα.",
    "rightDown":"Λήψη εικόνων χαμηλής ποιότητας",
    "history_will":"Θα λήξει μετά",
    "Expired":"(Εχει λήξει)",
	"uploadImage":"Προσθήκη εικόνας",
    "uploadImageInfo":"Ή αποθέστε το αρχείο εικόνας σας εδώ για να αφαιρέσετε το υδατογράφημα!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Απεριόριστος",
    "watermark_beyond_pixel_3":"Η επιλεγμένη εικόνα υπερβαίνει την <span>%s&times;%s ανάλυση</span>, αναβαθμίστε πρώτα το σχέδιό σας.",
    "watermark_beyond_size_3":"Η επιλεγμένη εικόνα υπερβαίνει τα <span>%sMB</span>, αναβαθμίστε πρώτα το σχέδιό σας.",
    "no_user_login":"Οι νέοι χρήστες που συνδέονται μπορούν να αποκτήσουν πλεονεκτήματα λήψης πρωτότυπων εικόνων ΔΥΟ HD.<span class=\"loginMaskbtn\">Σύνδεση αμέσως>></span>",
    "Upgrade":"Αναβαθμίζω",
    "Loading":"Φόρτωση…",
    "SelectAll":"Επιλογή όλων",
    "Open":"Ανοιξε",
    "Delete":"Διαγράφω",
    "Clear":"Διαγραφή μη έγκυρου",
    "noHistory":"Χωρίς Ιστορία",
    "Close":"Κλείσε",
    "buyUserInfo":"συγχαρητήρια! Αναβαθμίσατε με επιτυχία. Επιστρέψτε στην αρχική σελίδα και χρησιμοποιήστε αυτό το προϊόν.",
    "buyNoUserInfo":"Συγχαρητήρια! Αναβαθμίσατε με επιτυχία. Τα πλεονεκτήματα έχουν δεσμευτεί στη διεύθυνση ηλεκτρονικού ταχυδρομείου που αφήσατε κατά την αναβάθμιση. Χρησιμοποιήστε τον λογαριασμό που είναι καταχωρημένος ή συνδεδεμένος με τη διεύθυνση ηλεκτρονικού ταχυδρομείου για να <span class=\"loginMaskbtn\">συνδεθείτε για να χρησιμοποιήσετε τα οφέλη</span>. Εάν δεν έχετε εγγραφεί ή δεν έχετε συνδέσει λογαριασμό με τη διεύθυνση ηλεκτρονικού ταχυδρομείου, <span class=\"registerMaskbtn\">χρησιμοποιήστε τη διεύθυνση ηλεκτρονικού ταχυδρομείου για να καταχωρίσετε έναν λογαριασμό</span> ή συνδέστε άλλους λογαριασμούς σε αυτό το e- διεύθυνση αλληλογραφίας για τη χρήση παροχών.",
    "GetStarted":"Ξεκίνα",
    "AccessTo":"Πρόσβαση σε:",
    "imagesOfwatermarkremoval":"εικόνες αφαίρεσης υδατογραφήματος",
    "upTo":"Μέχρι και",
    "perImage":"ανά εικόνα",
    "Support":"Υποστήριξη",
    "resolution":"ανάλυση",
    "PrepaidPackage":"Προπληρωμένο Πακέτο",
    "PayasYouGo":"Pay as You Go",
    "TaxIncl":"Φόρος συμπερ.",
    "Checkout":"Ολοκλήρωση αγοράς",
    "imagesDay":"εικόνες/ημέρα",
    "imagesMonthly":"εικόνες/μηνιαίο",
    "image":"εικόνα",
    "images":"εικόνες",
    "imageSize":"μέγεθος εικόνας",
    "buyInfo1":"Ενσωματώσεις <span>βελτιωτή</span> τρίτου μέρους",
    "buyInfo2":"Το ιστορικό επεξεργασίας ισχύει για 7 ημέρες",
    "buyInfo3":"Επεξεργασία κατά προτεραιότητα",
    "buyInfo4":"Υποστήριξη πελατών 7x24",
    "buyInfo5":"Λήγει μετά από 24 ώρες",
    "buyInfo6":"Χωρίς συνδρομή. Χωρίς αυτόματη ανανέωση!",
    "buyInfo7":"Διαθέσιμο για χρήση οποιαδήποτε στιγμή για πάντα",
    "dayPlan":"Πρόγραμμα 1 ημέρας",
    "Lifetime":"Διάρκεια Ζωής",
    "note":"<span>Σημείωση</span>: Λάβετε υπόψη ότι το πακέτο που αγοράσατε συνδέεται με τη διεύθυνση ηλεκτρονικού ταχυδρομείου που παρέχεται κατά την ολοκλήρωση της αγοράς. Για να χρησιμοποιήσετε το πρόγραμμα με επιτυχία, εγγραφείτε ή συνδεθείτε με την ίδια διεύθυνση email.",
    "buy_now": "Αγορά τώρα",
    
    "banner_title": "Καθαρισμός φωτογραφιών AI - Πόσες πιστώσεις θέλετε",
    "banner_info": "1 Credit = 1 Εικόνα: Θα κοστίσετε 1 πίστωση για να επεξεργαστείτε και να αποθηκεύσετε μια εικόνα μεγαλύτερη από 600 × 600 pixels. ",
    "monthlyPlan_title": "Μηνιαίο σχέδιο",
    "monthlyPlan_displayPricePerCredit": "/πίστωση",
    "monthlyPlan_plan1_credits": "πιστώσεις/mo",
    "monthlyPlan_feature1": "<pan> χωρίς κίνδυνο: </span> εγγύηση χρημάτων 30 ημερών",
    "monthlyPlan_feature2": "<pan> αυτόματα: </span> Οι πιστώσεις ανανεώνονται αυτόματα",
    "monthlyPlan_feature3": "<pan> ευέλικτο: </span> υποβάθμιση, αναβάθμιση ή ακύρωση οποιαδήποτε στιγμή",
    "oneTimePurchase_title": "Εφάπαξ αγορά",
    "oneTimePurchase_plan5_credits": "πιστώσεις/διάρκεια ζωής",
    "oneTimePurchase_feature1": "Εγγύηση χρημάτων 30 ημερών",
    "oneTimePurchase_feature2": "Μόνιμα έγκυρη μετά την αγορά",
    "payment_title": "Μπορείτε να επιλέξετε πολλαπλές μεθόδους πληρωμής",
    "payment_image_alt": "Μέθοδοι πληρωμής",
    "faq_title": "Συχνές ερωτήσεις σχετικά με την αγορά πιστώσεων",
    "faq_question1_title": "Τι είναι οι πιστώσεις;",
    "faq_question1_info": "Η υπηρεσία μας μετράται στη μονάδα πιστώσεων. ",
    "faq_question2_title": "Πρέπει να επιλέξω μια μηνιαία συνδρομή ή μια εφάπαξ αγορά;",
    "faq_question2_info": "Για ακανόνιστες εργασίες εικόνας ή μια σπάνια απαίτηση χρήσης, μπορείτε να επιλέξετε μια εφάπαξ αγορά, όπου μπορείτε να αγοράσετε το σωστό ποσό πιστώσεων με βάση τις απαιτήσεις της εικόνας σας. ",
    "faq_question3_title": "Τι γίνεται αν χρησιμοποιήσω τις πιστώσεις μου;",
    "faq_question3_info": "Μπορείτε να αναβαθμίσετε τη συνδρομή σας ή να συνεχίσετε να αγοράζετε ένα σχέδιο αγοράς ενός χρόνου με βάση τις ανάγκες επεξεργασίας φωτογραφιών σας. ",
    "faq_question4_title": "Μπορώ να αναβαθμίσω, να υποβαθμίσω ή να ακυρώσω τη συνδρομή μου;",
    "faq_question4_info": "Ναι, μπορείτε. ",
    "whyChoose_title": "Γιατί να επιλέξετε το Tipard",
    "whyChoose_reason1_title": "Ασφαλής λήψη",
    "whyChoose_reason1_info": "Τα προγράμματα από το Tipard είναι 100% καθαρά και ασφαλή",
    "whyChoose_reason2_title": "Επαγγελματική τεχνολογία",
    "whyChoose_reason2_info": "Η εξειδικευμένη ομάδα παρέχει επαγγελματικά προϊόντα",
    "whyChoose_reason3_title": "24/7 Υποστήριξη πελατών",
    "whyChoose_reason3_info": "Υπηρεσίες συμβούλων ασθενών όλη την ώρα",
    "whyChoose_reason4_title": "30 ημέρες χρήματα πίσω",
    "whyChoose_reason4_info": "Εγγύηση επιστροφής χρημάτων σε χρήστες σε 30 ημέρες",
    "whyChoose_reason5_title": "Χρήστες 1.000.000+",
    "whyChoose_reason5_info": "Χρησιμοποιήθηκε και εμπιστεύεται πάνω από 1 εκατομμύριο άτομα",
    "whyChoose_reason6_title": "160+ χώρες",
    "whyChoose_reason6_info": "Πωλείται σε περισσότερες από 160 χώρες και περιοχές"
}